import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ChatPageState } from './chat-page.state';
import { LivekitService } from '../../core/services/livekit.service';
import { MibIconsModule, MibSpinnerComponent } from '@medinbox/angular';
import { MedinboxHeader } from '../mib-header/medinbox-header';
import { ChatTab } from './chat-tab/chat-tab';
import { VideoTab } from './video-tab/video-tab';
import { FooterActionBar } from '../footer-action-bar';
import { SmartphoneButton } from '../smartphone-button';
import { SessionWaiting } from '../session-waiting/session-waiting';
import { SessionTerminated } from '../session-terminated/session-terminated';

@Component({
  selector: 'app-chat-page',
  imports: [
    MibSpinnerComponent,
    MibIconsModule,
    MedinboxHeader,
    ChatTab,
    VideoTab,
    FooterActionBar,
    SmartphoneButton,
    SessionWaiting,
    SessionTerminated,
  ],
  templateUrl: './chat-page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatPage {
  protected readonly state = inject(ChatPageState);
  private readonly livekit = inject(LivekitService);

  readonly role = this.livekit.currentRole;
  readonly isWaiting = this.livekit.isWaiting;
  readonly isReady = this.livekit.isReady;
  /** True only when a session was established and has since ended (not the initial idle state). */
  readonly isTerminated = this.livekit.isTerminated;

  readonly mainAriaLabel = computed(() => `${this.role()} session`);

  readonly tabTransitionClasses = 'transition-all duration-480 ease-in-out';
  readonly videoTabClasses = computed(() => {
    const tabState = this.state.tabState();
    let flexBasis: string;
    switch (tabState.video) {
      case 'minimized':
        flexBasis = 'basis-0';
        break;
      case 'fullscreen':
        flexBasis = 'basis-full';
        break;
      default:
        flexBasis = 'basis-0';
        break;
    }
    return `${this.tabTransitionClasses} flex-1 ${flexBasis}`;
  });
  readonly chatTabClasses = computed(() => {
    const tabState = this.state.tabState();
    let flexBasis: string;
    switch (tabState.chat) {
      case 'minimized':
        flexBasis = 'basis-0';
        break;
      case 'fullscreen':
        flexBasis = 'basis-full';
        break;
      case 'default':
        flexBasis = 'md:basis-100 lg:basis-120 xl:basis-150 2xl:basis-192';
        break;
    }
    return `${this.tabTransitionClasses}  ${flexBasis}`;
  });
}
